import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { BookingScheduleInterface } from "../../Booking-Form/typings/booking.types";
import { BookingType } from "../../Booking-Form/typings/booking-inputs";
import { handleMultiDeleteBookings } from "../schedule.functions";
import { InactivateBookingsDto } from "../schedule.types";

type P = {
  schedules: BookingScheduleInterface[];
  selectedAppointments: number[];
  setDeletedBookings: (d: boolean) => void;
  inactivateBookings: (params: InactivateBookingsDto) => void;
};

export function ScheduleMultiDeleteButton({
  schedules,
  selectedAppointments,
  setDeletedBookings,
  inactivateBookings
}: Readonly<P>) {
  const { t } = useTranslation();

  return (
    <Button
      onClick={() =>
        handleMultiDeleteBookings({
          selectedSchedules: schedules
            .filter(sch => selectedAppointments.includes(sch.id))
            .map(s => ({ id: s.id, bookingType: s.bookingType as BookingType })),
          setDeletedBookings,
          inactivateBookings
        })
      }
      sx={{ background: "rgb(211, 47, 47)" }}
      color="error"
      data-testid="schedule-multi-delete-btn"
    >
      {t("DeleteBookings", { amount: selectedAppointments.length })}
    </Button>
  );
}
